import React from 'react';
import { SvgIcon } from '@material-ui/core';

export default function CheckIcon(): JSX.Element {
  return (
    <SvgIcon viewBox={'0 0 35.931 18.908'}>
      <g
        id="Groupe_400"
        data-name="Groupe 400"
        transform="translate(-338.424 -941.039)"
      >
        <g id="Groupe_388" data-name="Groupe 388" transform="translate(51 2)">
          <g
            id="Groupe_2"
            data-name="Groupe 2"
            transform="translate(287.926 939.541)"
          >
            <path
              id="Rectangle_2"
              data-name="Rectangle 2"
              d="M2,0H32.86a2,2,0,0,1,2,2V15.77a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z"
              transform="translate(0 0.138) rotate(-0.227)"
              fill="#fff"
            />
            <path
              id="Rectangle_2_-_Contour"
              data-name="Rectangle 2 - Contour"
              d="M2-.5H32.86a2.5,2.5,0,0,1,2.5,2.5V15.77a2.5,2.5,0,0,1-2.5,2.5H2a2.5,2.5,0,0,1-2.5-2.5V2A2.5,2.5,0,0,1,2-.5ZM32.86,17.266a1.5,1.5,0,0,0,1.5-1.5V2A1.5,1.5,0,0,0,32.86.5H2A1.5,1.5,0,0,0,.5,2V15.77a1.5,1.5,0,0,0,1.5,1.5Z"
              transform="translate(0 0.138) rotate(-0.227)"
              fill="#1a181b"
            />
            <text
              id="_"
              data-name="€"
              transform="translate(25.075 1.487) rotate(-0.227)"
              fill="#1a181b"
              fontSize="10"
              fontFamily="Helvetica"
            >
              <tspan x="0" y="8">
                €
              </tspan>
            </text>
            <path
              id="Tracé_12"
              data-name="Tracé 12"
              d="M0,3.859v-.83H26.358v.827ZM0,.828V0H26.358V.828Z"
              transform="translate(3.48 10.622) rotate(-0.227)"
              fill="#1a181b"
            />
          </g>
          <g
            id="Groupe_3"
            data-name="Groupe 3"
            transform="translate(291.672 942.955)"
          >
            <path
              id="Tracé_13"
              data-name="Tracé 13"
              d="M1.563,3.025A1.681,1.681,0,0,1,.94,2.913,1.46,1.46,0,0,1,.446,2.6a1.479,1.479,0,0,1-.327-.48,1.6,1.6,0,0,1,0-1.208A1.472,1.472,0,0,1,.451.429a1.488,1.488,0,0,1,.5-.317A1.786,1.786,0,0,1,2.2.116,1.3,1.3,0,0,1,2.7.461L2.42.727A1.1,1.1,0,0,0,2.04.461,1.191,1.191,0,0,0,1.588.374a1.256,1.256,0,0,0-.466.085A1.109,1.109,0,0,0,.752.695a1.058,1.058,0,0,0-.243.361,1.235,1.235,0,0,0,0,.909,1.056,1.056,0,0,0,.243.361,1.09,1.09,0,0,0,.369.237,1.243,1.243,0,0,0,.466.084,1.179,1.179,0,0,0,.453-.087,1.077,1.077,0,0,0,.38-.266l.275.266a1.313,1.313,0,0,1-.493.346,1.659,1.659,0,0,1-.64.118Z"
              transform="translate(0 0.791) rotate(-0.227)"
            />
            <path
              id="Tracé_14"
              data-name="Tracé 14"
              d="M.423,2.957H0V0H.423ZM2.16,1.639H.381V1.271H2.16ZM2.121,0h.423V2.957H2.121Z"
              transform="translate(3.296 0.812) rotate(-0.227)"
            />
            <path
              id="Tracé_15"
              data-name="Tracé 15"
              d="M.423,3.38H2.147v.367H0V.79H2.087v.367H.423ZM.984.549.275,0H.79l.575.549Zm-.6,1.517H1.907v.359H.385Z"
              transform="translate(6.722 0.008) rotate(-0.227)"
            />
            <path
              id="Tracé_16"
              data-name="Tracé 16"
              d="M1.576,3.022a1.686,1.686,0,0,1-.628-.114,1.492,1.492,0,0,1-.5-.318,1.457,1.457,0,0,1-.329-.48,1.579,1.579,0,0,1,0-1.2A1.461,1.461,0,0,1,.448.432a1.5,1.5,0,0,1,.5-.319A1.8,1.8,0,0,1,2.2.113,1.5,1.5,0,0,1,2.7.43a1.452,1.452,0,0,1,.327.481,1.539,1.539,0,0,1,.116.6,1.523,1.523,0,0,1-.116.6A1.446,1.446,0,0,1,2.7,2.6a1.486,1.486,0,0,1-.5.317,1.7,1.7,0,0,1-.626.108Zm0-.376a1.207,1.207,0,0,0,.459-.085,1.057,1.057,0,0,0,.363-.24,1.132,1.132,0,0,0,.241-.363,1.145,1.145,0,0,0,.087-.448,1.162,1.162,0,0,0-.087-.453A1.106,1.106,0,0,0,2.393.7,1.081,1.081,0,0,0,2.03.458a1.273,1.273,0,0,0-.913,0A1.117,1.117,0,0,0,.752.7a1.1,1.1,0,0,0-.243.361,1.162,1.162,0,0,0-.087.453,1.145,1.145,0,0,0,.087.448,1.124,1.124,0,0,0,.243.363,1.091,1.091,0,0,0,.365.24,1.2,1.2,0,0,0,.454.085Zm.972.959a1.065,1.065,0,0,1-.283-.036,1.121,1.121,0,0,1-.271-.114,1.864,1.864,0,0,1-.279-.2A4.236,4.236,0,0,1,1.4,2.95l.453-.119a1.984,1.984,0,0,0,.243.256.79.79,0,0,0,.23.144.616.616,0,0,0,.228.045.694.694,0,0,0,.537-.254l.2.241a.923.923,0,0,1-.745.343Z"
              transform="translate(9.313 0.757) rotate(-0.227)"
            />
            <path
              id="Tracé_17"
              data-name="Tracé 17"
              d="M1.253,2.99a1.236,1.236,0,0,1-.917-.333A1.319,1.319,0,0,1,0,1.681V0H.426V1.664a1.018,1.018,0,0,0,.218.722.948.948,0,0,0,1.234,0A1.021,1.021,0,0,0,2.1,1.664V0h.41V1.681a1.324,1.324,0,0,1-.333.976,1.235,1.235,0,0,1-.92.333Z"
              transform="translate(13.075 0.775) rotate(-0.227)"
            />
            <path
              id="Tracé_18"
              data-name="Tracé 18"
              d="M.423,2.59H2.147v.367H0V0H2.087V.367H.423ZM.384,1.276H1.906v.359H.384Z"
              transform="translate(16.443 0.76) rotate(-0.227)"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}
